/* v8 ignore start */
import { useParams } from 'react-router-dom'
import { assertNever } from '@which/shared'

import type {
  LatestNews,
  SubVerticalCampaignPetitionQuery,
  SubVerticalCrScamsTopicPageQuery,
  SubVerticalCrTopicPageQuery,
  SubVerticalHubPageQuery,
  SubVerticalNewsPageQuery,
  SubVerticalPolicyAndInsightLandingQuery,
  SubVerticalReviewsPageQuery,
} from '../../../generated/frontend'
import type { PageParams } from '../../../routes'
import { usePageProps } from '../../../shared/usePageProps'
import type { SubVerticalTemplateName, SubVerticalVariantTypes } from '../sub-vertical-types'
import { getSubVerticalCampaignPetitionComponents } from '../sub-vertical-variants/campaigns-petition'
import { getSubVerticalCRScamsTopicComponents } from '../sub-vertical-variants/cr-scams-topic'
import { getSubVerticalCRTopicComponents } from '../sub-vertical-variants/cr-topic'
import { getSubVerticalHubComponents } from '../sub-vertical-variants/hub-page'
import { getSubVerticalNewsComponents } from '../sub-vertical-variants/news-sub-vertical'
import { getSubVerticalPolicyAndInsightLandingComponents } from '../sub-vertical-variants/policy-and-insight-landing'
import { getSubVerticalReviewsComponents } from '../sub-vertical-variants/reviews-sub-vertical'

export const useSubVerticalComponents = () => {
  const { template, context } = usePageProps()
  const subVerticalTemplate = template as SubVerticalTemplateName
  const { verticalSlug, subVerticalSlug } = useParams<PageParams>()

  return {
    getComponents(data: SubVerticalVariantTypes, latestNews?: LatestNews) {
      switch (subVerticalTemplate) {
        case 'CR Topic':
          return getSubVerticalCRTopicComponents(
            data as SubVerticalCrTopicPageQuery['subVerticalPage']
          )
        case 'CR Scams Topic':
          return getSubVerticalCRScamsTopicComponents(
            data as SubVerticalCrScamsTopicPageQuery['subVerticalPage'],
            latestNews
          )
        case 'Subvertical':
          return getSubVerticalReviewsComponents(
            data as SubVerticalReviewsPageQuery['subVerticalPage']
          )
        case 'News Category Listing':
          return getSubVerticalNewsComponents(data as SubVerticalNewsPageQuery['subVerticalPage'], {
            subVerticalSlug,
            context: context || '',
            verticalSlug,
          })
        case 'Hub Page':
          return getSubVerticalHubComponents(data as SubVerticalHubPageQuery['subVerticalPage'])
        case 'Campaigns Petition':
          return getSubVerticalCampaignPetitionComponents(
            data as SubVerticalCampaignPetitionQuery['subVerticalPage']
          )
        case 'Policy and Insight Landing Page':
          return getSubVerticalPolicyAndInsightLandingComponents(
            data as SubVerticalPolicyAndInsightLandingQuery['subVerticalPage']
          )
        default:
          assertNever(subVerticalTemplate)
      }
    },
  }
}

/* v8 ignore stop */
